import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { concatMap, map } from 'rxjs/operators';
import { BasePayrollComponent } from '../../../../components/base/base-payroll.component';
import {
  MasterPayrollObject,
  PayrollConfigSetupData,
  PayrollStartData,
  PayTypes
} from '../../../../models/payroll';
import { PayrollService } from '../../../../services/payroll.service';
import { PayrollManagement } from '../../../../tools/payroll-management';

@Component({
  selector: 'lib-manual-payroll-preview',
  templateUrl: './manual-payroll-preview.component.html',
  styleUrls: ['./manual-payroll-preview.component.css'],
  standalone: false
})
export class ManualPayrollPreviewComponent extends BasePayrollComponent implements OnInit {
  clientCode: string;
  payroll: MasterPayrollObject;
  startData: PayrollStartData;
  configSetupData: PayrollConfigSetupData;

  constructor(
    private payrollMgmt: PayrollManagement,
    private payrollSvc: PayrollService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.payrollMgmt
      .getManualPayroll(this.clientCode, this.year, this.seqNo)
      .pipe(
        concatMap(p => {
          this.payroll = p;

          // error condition - payroll type doesn't match up.
          if (this.payroll.PayType != PayTypes.Manual) {
            this.router.navigate([`/client/${this.clientCode}/payroll-landing`]);
          }

          return this.payrollSvc
            .getPayrollConfigSetupData(
              p.ClientCode,
              p.Calendars,
              p.LocationId,
              p.PayDate,
              p.PayType
            )
            .pipe(map(setupData => (this.configSetupData = setupData)));
        })
      )
      .subscribe();

    this.payrollSvc
      .getPayrollStartData(this.clientCode)
      .pipe(map(data => (this.startData = data)))
      .subscribe();
  }

  returnToHub() {
    this.router.navigate([`/client/${this.clientCode}/payroll-landing`]);
  }

  public print() {
    window.print();
  }
}
